// extracted by mini-css-extract-plugin
export default {"menu-list":"Menu_menu-list__BmLCd","menu-inner":"Menu_menu-inner__6VLNq","menu-item":"Menu_menu-item__FCdJi","separate":"Menu_separate__WoUUQ"};